export const URL_MAP = {
  accountNames: 'get_account_names',
  accountStats: 'get_account_stats',
  accountVisibility: 'account_visibility',
  assetDropdown: 'get_assets_dropdown',
  getCountries: 'get_countries',
  getAllCountries: 'get_all_countries',
  setLanguage: 'set_language',
  getSourceOfFunds: 'get_source_of_funds',
  newAssetDropdown: 'get_new_deposit_dropdown',
  supportedDocuments: 'supported_documents',
  balances: 'get_balances',
  changePassword: 'change_password',
  updateDetails: 'update_details',
  verifyLogin: 'verify_login',
  setAvatar: 'set_avatar',
  createDepositPlan: 'create_deposit_plan',
  deleteUser: 'delete_user',
  delTotp: 'del_totp',
  changePasswordRequest: 'change_password_request',
  changePasswordConfirmation: 'change_password_confirmation',
  depositDropdown: 'get_deposit_dropdown',
  depositPlans: 'get_deposit_plans',
  details: 'details',
  internalTransfer: 'internal_transfer',
  lastIps: 'get_last_ips',
  login: 'login',
  logout: 'logout',
  newDepositDropdown: 'get_new_deposit_dropdown',
  register: 'register',
  verifyBonusCode: 'verify_promocode',
  resendCode: 'resend_code',
  resendConfirmationCode: 'resend_confirmation_code',
  resendWithdrawalCode: 'resend_withdrawal_code',
  resetPassword: 'reset_password',
  supportedCoins: 'supported_coins',
  updateUserSettings: 'update_user_settings',
  totp: 'add_totp',
  transactionsList: 'get_transactions_list',
  cancelWithdrawal: 'cancel_withdrawal',
  userWallet: 'get_user_wallet',
  deleteUserCheck: 'delete_user_check',
  verify: 'verify',
  waitList: 'join_waitlist',
  withdrawFundsConfirmation: 'withdraw_funds_confirmation',
  withdrawFundsRequest: 'withdraw_funds_request',
  sendRefCode: 'send_ref_code',
  getReferralsList: 'get_referrals_list',
  getUserFrozenBonusList: 'frozen_bonus/list',
  tokenStats: 'get_token_stats',
  supportedTokens: 'supported_tokens',
  tokenSwap: 'token_swap',
  getUserBorrow: 'get_borrow_stats',
  getUserLoan: 'get_user_loan',
  repayUserLoan: 'repay_user_loan',
  getLoanStats: 'get_loan_stats',
  getAds: 'get_ads',
  vestingList: 'get_vesting_csv',
  setPayoutCurrency: 'set_payout_currency',
  governance: 'governance/active',
  setGovernanceVote: 'governance/vote',
  governanceVotingHistory: 'governance/history',
  historicalTokenBalance: 'governance/historical_token_balance',
  kycToken: 'v2/kyc/token'
};
